
import React from 'react';
import { UseFormReturn } from "react-hook-form";
import { TerraceFormValues } from "./types";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";

interface TerraceDescriptionProps {
  form: UseFormReturn<TerraceFormValues>;
  disabled?: boolean;
}

const TerraceDescription: React.FC<TerraceDescriptionProps> = ({ form, disabled = false }) => {
  return (
    <FormField
      control={form.control}
      name="terraceDescription"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Description</FormLabel>
          <FormControl>
            <Textarea 
              placeholder="Tell us about this terrace. What makes it special? When does it get sun?" 
              className={`min-h-[100px] ${disabled ? "bg-muted text-muted-foreground" : ""}`}
              disabled={disabled}
              {...field} 
            />
          </FormControl>
          {disabled && (
            <FormDescription>
              This will be filled automatically from the Google Maps link
            </FormDescription>
          )}
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default TerraceDescription;
